<template>
  <v-app>

    <!-- <the-header-profile /> -->

    <router-view :key="$route.path"></router-view>

  </v-app>
</template>

<script>
// import TheHeaderProfile from "@/containers/TheHeaderProfile";

export default {
  name: "TheContainer",
  components: {
    // TheHeaderProfile,
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.v-main{
  padding: 60px 0 !important;
}
</style>
